module.exports = __webpack_public_path__ + "static/media/playButton.1b59513b.svg";